import API from "./API";
import axios from "axios";

export const Indents = {

    async create(indent){
        const url = API.url('/indents');
        return await axios.post(url, indent);
    },

    async get(uuid, pin){
        let url = API.url(`/indents/${uuid}`);
        url += pin ? `?pin=${pin}` : '';
        return await axios.get(url);
    },

    async confirm(indent, pin){
        let url = API.url(`/indents/${indent.uuid}/confirm`);
        url += pin ? `?pin=${pin}` : '';
        return await axios.put(url, indent);
    },

    async validate(uuid, pin){
        let url = API.url(`/indents/${uuid}/validate`);
        url += pin ? `?pin=${pin}` : '';
        return await axios.put(url);
    },

    async search(start, end){
        const url = API.url(`/indents?since=${start}&until=${end}`);
        return await axios.get(url);
    },

    async publish(id){
        let url = API.url(`/indents/${id}/publish`);
        return await axios.put(url);
    },

    async delete(id){
        let url = API.url(`/indents/${id}`);
        return await axios.delete(url);
    },

    async setPaid(id){
        let url = API.url(`/indents/${id}/paid`);
        return await axios.put(url);
    },

    createProductFromReward(reward){
        return {
            id: 'reward_' + reward.id,
            class: 'reward',
            code: reward.id,
            title: reward.title,
            quantity: 1,
            price: 0,
            taxRate: 0
        }
    },

    createProductFromCourse(course, mode, price){
        return {
            id: 'course_' + course.id,
            class: 'course',
            code: course.id,
            title: course.title,
            quantity: 1,
            price: price || 0,
            taxRate: 0,
            mode: mode || 'standard'
        }
    },

    createProductFromConference(conference, price){
        return {
            id: 'conference_' + conference.id,
            class: 'conference',
            code: conference.id,
            title: conference.title,
            quantity: 1,
            price: price || 0,
            taxRate: 0,
            mode: null
        }
    }

}

export default Indents;